import moment from 'moment';
import { emptyValue } from '../shared/constants';
import { timeInStageBorders } from './constants';

type TimeInStageColor = 'success.main' | 'warning.main' | 'error.main' | 'text.primary';

interface TimeInStage {
  label: string;
  color: TimeInStageColor;
}

const getColor = (days: number): TimeInStageColor => {
  if (days >= timeInStageBorders.errorDays) {
    return 'error.main';
  }

  return days >= timeInStageBorders.warningDays ? 'warning.main' : 'success.main';
};

const getLabel = (spent: moment.Duration) => {
  const days = Math.floor(spent.asDays());

  if (days) {
    return `${days}d ${spent.hours()}h`;
  }

  return spent.hours() ? `${spent.hours()}h ${spent.minutes()}m` : `${spent.minutes()}m`;
};

const emptyTimeInStage: TimeInStage = { label: emptyValue, color: 'text.primary' };

export const getTimeInStage = (createdAt?: string): TimeInStage => {
  const enteredAt = moment.utc(createdAt);

  if (!enteredAt.isValid()) {
    return emptyTimeInStage;
  }

  const spent = moment.duration(moment.utc().diff(enteredAt));

  return spent.asDays() < 0 ? emptyTimeInStage : { label: getLabel(spent), color: getColor(spent.asDays()) };
};
